/**
 * authFetch — Fetch wrapper with 30s timeout.
 * Cookies sent automatically (HttpOnly, same-origin).
 *
 * Extracted from index.html (previously inline ~line 1261).
 */

const AUTH_FETCH_TIMEOUT = 30000;

/**
 * @param {string} url
 * @param {RequestInit} [options]
 * @returns {Promise<Response>}
 */
export const authFetch = (url, { timeoutMs = AUTH_FETCH_TIMEOUT, ...options } = {}) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), timeoutMs);
    const headers = { ...options.headers };
    if (options.body && typeof options.body === 'string') {
        headers['Content-Type'] = headers['Content-Type'] || 'application/json';
    }
    return fetch(url, {
        ...options,
        headers,
        signal: controller.signal,
        credentials: 'same-origin',
    })
        .then(async (r) => {
            const ct = r.headers.get('content-type') || '';
            if (!r.ok && !ct.includes('application/json')) {
                throw new Error(
                    r.status === 502 || r.status === 503
                        ? 'Server er midlertidig utilgjengelig. Prøv igjen.'
                        : `Serverfeil (${r.status})`,
                );
            }
            // For proxy errors with hints — clone, peek at hint, attach to response
            if (!r.ok && ct.includes('application/json') && url.includes('/api/proxy')) {
                const clone = r.clone();
                try {
                    const d = await clone.json();
                    if (d.hint) r._hint = d.hint;
                } catch (_e) { /* ignore parse errors */ }
            }
            return r;
        })
        .finally(() => clearTimeout(timeout));
};

export default authFetch;
